export const customTransitionTokens = {
    hover: '150ms cubic-bezier(0.215, 0.61, 0.355, 1)'
};

//# sourceMappingURL=transition.js.map